module.exports = {"username":"Benutzername","password":"Passwort","login":"Anmelden","errors":{"username-required":"Der Benutzername ist eine Pflichtangabe und darf nicht leer sein","password-required":"Das Passwort ist eine Pflichtangabe und darf nicht leer sein","4c6e7474-1892-43f3-baf9-b8a8b9ea2be5":"Benutzername oder Passwort nicht gefunden"}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/de/login-form.json
// module id = zcxc
// module chunks = 1